import { blue, green, grey, orange } from '@mui/material/colors'
import { createDateFromString, formatDateToBEFormatDateFns } from 'utils/date'

export const BILLING_TO_HEATMAP_VALUE = {
  EMPTY: 0,
  UN_BILLED: 1,
  BILLED: 2,
  GRACE_PERIOD: 3,
}

const { EMPTY, UN_BILLED, BILLED, GRACE_PERIOD } = BILLING_TO_HEATMAP_VALUE

export const HEATMAP_VALUE_TO_BILLING = {
  [EMPTY]: {
    type: 'Empty',
    color: grey[100],
  },
  [UN_BILLED]: {
    type: 'Unbilled',
    color: orange[300],
  },
  [BILLED]: {
    type: 'Billed',
    color: green[300],
  },
  [GRACE_PERIOD]: {
    type: 'Grace period',
    color: blue[300],
  },
}

export const CHART_LEGEND = [
  {
    label: HEATMAP_VALUE_TO_BILLING[UN_BILLED].type,
    color: HEATMAP_VALUE_TO_BILLING[UN_BILLED].color,
  },
  {
    label: HEATMAP_VALUE_TO_BILLING[GRACE_PERIOD].type,
    color: HEATMAP_VALUE_TO_BILLING[GRACE_PERIOD].color,
  },
  {
    label: HEATMAP_VALUE_TO_BILLING[BILLED].type,
    color: HEATMAP_VALUE_TO_BILLING[BILLED].color,
  },
]

export const colorScaleFn = value => {
  const mappedValue = HEATMAP_VALUE_TO_BILLING[value]
  return mappedValue ? mappedValue.color : grey[100] // Default to grey[100] if not found
}

colorScaleFn.ticks = () => [0, 1, 2, 3, 4]

const getDates = (startDate, endDate, type) => {
  const data = []
  const currentDate = createDateFromString(startDate)
  const end = createDateFromString(endDate)
  if (!currentDate || !end) return data
  while (currentDate <= end) {
    data.push({ day: formatDateToBEFormatDateFns(currentDate), value: type })
    currentDate.setDate(currentDate.getDate() + 1)
  }
  return data
}

export const formatHeatmapData = (data = {}) => {
  const { unbilledPeriods = [], billedPeriods = [], gracePeriods = [] } = data
  const heatmapData = []

  gracePeriods.forEach(({ startDate, endDate }) => {
    heatmapData.push(...getDates(startDate, endDate, GRACE_PERIOD))
  })

  billedPeriods.forEach(({ startDate, endDate }) => {
    heatmapData.push(...getDates(startDate, endDate, BILLED))
  })

  unbilledPeriods.forEach(({ startDate, endDate }) => {
    heatmapData.push(...getDates(startDate, endDate, UN_BILLED))
  })

  return heatmapData
}
